import { combineReducers } from 'redux';

// global store
import bannerAppData from 'src/store/appBanners/slice';
import error from 'src/store/error/slice';
import popup from 'src/store/popup/slice';
import feedback from '../../../store/feedback/slices';
import client from '../../../store/client/reducers';
import logo from '../../../store/logo/reducers';
import menu from '../../../store/menu/slice';
import payment from '../../../store/payment/slice';
import enqueue from '../../../store/enqueue/reducers';
import headerWidget from '../../../store/headerWidget/reducers';
import wishlist from '../../../store/wishlist/slice';

import certificate from './certificate/slice';
import view from './view/slice';

const rootReducer = combineReducers({
  feedback,
  client,
  logo,
  menu,
  popup,
  error,
  payment,
  enqueue,
  headerWidget,
  wishlist,
  bannerAppData,
  //
  view,
  certificate,
});

export default rootReducer;
